// extracted by mini-css-extract-plugin
export default {"CTA":"styles_CTA__31ERM","float_up":"styles_float_up__wCbyi","CTAsmall":"styles_CTAsmall__lXcH+","StepHeading":"styles_StepHeading__At5K5"};